import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgStoreV2 = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 17"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M14.282.375c.973 0 1.88.528 2.319 1.39l1.43 2.815.074.157c.6 1.407-.274 2.888-1.663 3.273v7.18h1.225l.126.013a.626.626 0 0 1 0 1.225l-.126.012H1a.625.625 0 1 1 0-1.25h1.226V8.01C.786 7.61-.1 6.032.636 4.58l1.43-2.813.087-.159C2.618.84 3.473.375 4.385.375zm-3.721 11.736a1.227 1.227 0 0 0-2.454 0v3.08h2.454zM4.385 1.625c-.463 0-.875.22-1.113.556l-.092.151L1.75 5.146c-.378.744.163 1.701 1.169 1.71.937-.002 1.511-.622 1.514-1.177v-.04a.625.625 0 0 1 1.237-.125l.013.126.006.11c.068.554.64 1.106 1.507 1.106.926 0 1.513-.628 1.513-1.216a.625.625 0 0 1 1.237-.126l.013.126.007.11c.068.554.638 1.106 1.507 1.106.925 0 1.512-.628 1.512-1.216a.625.625 0 0 1 1.238-.126l.012.126v.039c0 .554.573 1.175 1.511 1.176.944-.007 1.479-.849 1.23-1.567l-.06-.142-1.43-2.814c-.213-.42-.675-.707-1.205-.707zM11.81 15.19h3.381V8.055a2.896 2.896 0 0 1-1.588-.844c-.523.558-1.308.895-2.13.895-.827 0-1.617-.34-2.139-.904-.522.564-1.311.904-2.138.904-.823 0-1.61-.337-2.133-.897a2.895 2.895 0 0 1-1.588.846v7.135h3.381v-3.079a2.477 2.477 0 0 1 4.954 0z" />
    </svg>
  );
};
export default SvgStoreV2;
